// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1h09HhCVArV44-lyAqB5Ap{color:#555;display:flex}._2LvZQ9uix_h3MYzO9J9_5u{display:flex;flex-direction:column}._2Has6x_1NCehQf9h7Pb9w_{color:#111;margin-bottom:.8rem}.M5ury4p9hQlrzHnFYgsWl{border-radius:1rem;display:block;height:3.2rem!important;margin-right:1.2rem;min-width:3.2rem;overflow:hidden}@media (min-width:992px){.M5ury4p9hQlrzHnFYgsWl{height:4rem!important;margin-right:2.4rem;min-width:4rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"author": "_1h09HhCVArV44-lyAqB5Ap",
	"textContainer": "_2LvZQ9uix_h3MYzO9J9_5u",
	"name": "_2Has6x_1NCehQf9h7Pb9w_",
	"image": "M5ury4p9hQlrzHnFYgsWl"
};
module.exports = ___CSS_LOADER_EXPORT___;
